import React, { Component } from "react";
import "./hamburger.scss";
class Hamburger extends Component {
    handleKeyDown() {}
    render() {
        let state = this.props.open ? "open" : "closed";
        let color = this.props.color || "#FFFFFF";
        let style = {
            backgroundColor: color,
        };
        return (
            <div
                className={`hamburger ${state} `}
                id={"hamburger"}
                onClick={this.props.onClick}
                onKeyDown={this.handleKeyDown}
                role={"button"}
            >
                <span style={style} />
                <span style={style} />
                <span style={style} />

            </div>
        );
    }
}

export default Hamburger;